module.exports = __webpack_public_path__ + "6454dd769e1e9868719e0acdff3fd4f1.svg";